<template>
  <div id="page">
    <section class="jobs">
      <div class="jobs-detail">
        <div class="detail">
          <div class="detail-hd">
            <div onclick="window.history.back(-1);">
              <svg
                t="1634093854801"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2621"
                width="18"
                height="18"
              >
                <path
                  d="M274.510074 461.204104c130.168642-125.846196 260.332167-251.684206 390.490575-377.400442 53.595662-51.864228 133.49848 32.354895 79.653131 84.346013-115.838262 112.008027-231.6755 223.893256-347.450317 335.904353C513.596358 619.888196 629.989251 735.852324 746.444567 851.690586c52.978609 52.733015-26.921139 136.953162-79.712483 84.282568C535.946388 805.873074 405.233348 675.710572 274.510074 545.546024 252.90194 523.93789 252.342192 482.563574 274.510074 461.204104L274.510074 461.204104zM274.510074 461.204104"
                  p-id="2622"
                  fill="#666666"
                ></path>
              </svg>
            </div>
            <span>招聘职位</span>
          </div>
          <div class="top-info">
            <div class="content-hd">
              <h4><span v-show="detail.hot" class="ji">急</span>{{ detail.workName }}</h4>
              <p class="color-on">{{ detail.salary }}</p>
            </div>
            <div class="content-bd">
              <p>{{ detail.dept.deptName }}</p>
              <p class="area">{{ detail.province }}</p>
            </div>
          </div>
          <h4>职位描述</h4>
          <div class="post">
            <h4>岗位职责</h4>
            <div class="desc" v-html="detail.workInfo"></div>
          </div>
          <div class="post">
            <h4>职位要求</h4>
            <div class="desc" v-html="detail.workRequirments"></div>
          </div>
          <div class="post">
            <h4>福利待遇</h4>
            <div class="desc">
              <p>薪酬：<span v-text="detail.salary"></span></p>
              <div class="welfare">
                <p>福利：</p>
                <p v-html="detail.workWelfare"></p>
              </div>
            </div>
          </div>
          <div class="deliver-wrap">
            <router-link to="/resume" class="deliver" target="_blank">
              投递简历
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "jobsdetail",
  data() {
    return {
      detail: null,
    };
  },
  created() {
    let arr = location.href.split("/");
    let curr_new = arr[arr.length - 1];
    let that = this;
    this.$ajax
      .get("/getJobsDetail/" + curr_new)
      .then(function (res) {
        that.detail = res.jobsDetail;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.jobs {

  padding-top: 5rem;
  background-color: #fff;

  .title {
    font-size: 32px !important;
    line-height: 45px !important;
    color: #333 !important;
  }
  .datetime {
    color: #999;
    text-indent: 0 !important;
    margin-bottom: 1rem;
  }
  > p {
    line-height: 1em;
    color: #999;
    margin-bottom: 28px;
  }
  .jobs-detail {
    .detail {
      .detail-hd {
        display: flex;
        justify-content: space-between;
        padding: 0.5rem 1rem;
        border-bottom: 2px solid rgb(245, 245, 245);
        > div {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        > span {
          display: block;
          height: 30px;
          line-height: 30px;
          text-align: center;
          width: 100%;
          font-size: 1rem;
          font-weight: bold;
          color: #666;
          cursor: pointer;
        }
      }

      p {
        color: #535353;
        padding: 5px 0;
        font-size: px2rem(16);
        line-height: 2em;
        font-family: "helvetica";
      }
      .top-info {
        padding: 1rem;
        cursor: pointer;
        border-bottom: 5px solid rgb(245, 245, 245);
        .ji{
          padding: .2rem .3rem;
          background-color: #FF6B6B;
          text-align: center;
          color: #fff;
          margin-right: .3rem;
          font-size: .8rem !important;
        }
        p {
          color: #999;
          line-height: 30px;
        }
        > .content-hd {
          display: flex;
          justify-content: space-between;
          > h4 {
            font-size: 1.2rem;
            line-height: 2.5rem;
          }
          .color-on {
            margin-left: 2%;
            color: #ff6b6b;
            font-size: 1.2rem;
          }
        }
        > .content-bd {
          display: flex;
          justify-content: flex-start;
          .area {
            margin-left: 0.5rem;
          }
        }
        > .content-ft {
          display: flex;
          justify-content: space-between;
          p {
            &:last-child {
              font-size: 12px;
            }
          }
        }
      }
      > h4 {
        padding: 1rem;
        font-size: 1.2rem;
      }

      .post {
        h4,
        p,
        span {
          color: #535353;
        }
        padding: 1rem;
        > h4 {
          font-size: 1rem;
          line-height: 1.2rem;
          color: #535353;
          margin-bottom: 10px;
          .color-div {
            display: inline-block;
            width: 4px;
            height: 20px;
            background-color: #b21010;
            position: relative;
            top: 5px;
            margin-right: 10px;
          }
        }
        .welfare {
          display: flex;
        }
      }
      .deliver-wrap {
        display: flex;
        justify-content: center;
        margin-bottom: 1rem;
        .deliver {
          font-size: 0.8rem;
          display: block;
          width: 30%;
          color: #fff;
          border: 1px solid;
          background-color: rgb(178, 16, 16);
          padding: 0.5rem 0;
          border-radius: 1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/jobsdetail.vue